import React from "react";
import PropTypes from "prop-types";
import {IconButton, makeStyles} from "@material-ui/core";
import {Close as CancelIcon, PlayCircleFilled as VideoIcon} from "@material-ui/icons";
import Popover from "@material-ui/core/Popover";
import Card from "@material-ui/core/Card/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import ReactWebMediaPlayer from "react-web-media-player";

const useStyles = makeStyles(theme => ({
    root: {},
    iconButton: {
        padding: "6px"
    },
    gridCard: {
        width: "560px",
        boxShadow: '0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 2px 0px rgba(0,0,0,0.14), 0px 0px 5px 0px rgba(0,0,0,0.12)',
        height: '350px',
    },
    label: {
        fontSize: 10,
        fontWeight: theme.typography.fontWeightBold,
    },
    cardHeader: {
        padding: '5px 16px',
        borderBottom: '1px outset rgba(0, 0, 0, 0.12)',
        '& .MuiCardHeader-action': {
            marginTop: '0px',
            '& .MuiIconButton-root': {
                padding: '2px'
            }
        }
    },
    cardContent: {
        padding: '0px'
    }
}));

function VideoPopoverIcon(props) {
    const {url, serialNumber} = props;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const classes = useStyles();

    const handleCLick = event => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (event) => {
        event.stopPropagation();
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    return (
        <div className={classes.root}>
            {
                <IconButton
                    disabled={!url}
                    color="secondary"
                    className={classes.iconButton}
                    onClick={handleCLick}
                >
                    <VideoIcon/>
                </IconButton>
            }

            <Popover
                onClick={(event) => event.stopPropagation()}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Card className={classes.gridCard}>
                    <CardHeader
                        className={classes.cardHeader}
                        title={`ID: ${serialNumber}`}
                        titleTypographyProps={{variant: 'button'}}
                        action={
                            <IconButton aria-label="cancel" onClick={handleClose}>
                                <CancelIcon/>
                            </IconButton>
                        }
                    />
                    <CardContent className={classes.cardContent}>
                        {
                            url &&
                            <ReactWebMediaPlayer
                                video={url}
                            />
                        }
                    </CardContent>
                </Card>
            </Popover>
        </div>
    );
}

VideoPopoverIcon.PropType = {
    url: PropTypes.string.isRequired,
    serialNumber: PropTypes.string.isRequired,
};

export default VideoPopoverIcon;
